import { get, find, map, chain } from "lodash"
import { createSelector } from "reselect"

const getPortfolios = state => get(state, "global.data.portfolios.data")
const getRawSelectedPortfolios = state => get(state, "global.data.subscriptions.data.portfolioIds")

export const getAvailablePortfolios = createSelector(
  [getPortfolios],
  (portfolios) => map(portfolios, p => ({ value: p.id, label: p.name })),
)

export const getSelectedPortfolios = createSelector(
  [getRawSelectedPortfolios, getPortfolios],
  (selectedPortfolios, portfolios) =>
    chain(selectedPortfolios)
      .map(selectedPortfolioId => {
        const portfolioData = find(portfolios, p => selectedPortfolioId === p.id)
        // portfolio is missing
        if (!portfolioData) {
          return null
        }
        return { value: selectedPortfolioId, label: portfolioData.name }
      })
      .filter(p => p !== null)
      .value(),
)
